const serverUrl = "http://pluvid.com/deuilbackend/";

class AjaxCalls {
	
	getRequest(url) {
		var init = {
		  method: "GET"
		}; 
		var request = new Request(url, init);
		return request;
	}
	
	postRequest(url, data) {
		var init = {
			method: "POST",
			body: data
		}; 
		var request = new Request(url, init);
		return request;
	}
	
	getText(url) {
		return fetch(url)
		.then(function(response) {
			return response.text();
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	getJson(url) {		
		return fetch(url)
		.then(function(response) {			
			return response.json();
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	postIsland(json) {
		var data = new FormData();
		data.append( "island", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}
	
	postCharacters(json) {
		var data = new FormData();
		data.append( "characters", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}
	
	postBox(json) {
		var data = new FormData();
		data.append( "box", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}
	
	postJoe(json) {
		var data = new FormData();
		data.append( "joe", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}	
	
	postRumors(json) {
		var data = new FormData();
		data.append( "rumors", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}

	postReports(json) {
		var data = new FormData();
		data.append( "reports", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}

	postBestiary(json) {
		var data = new FormData();
		data.append( "bestiary", JSON.stringify( json ) );
		var request = this.postRequest(serverUrl + "broccoli.php", data);
		return this.getText(request);
	}
	
	getIsland() {
		var request = this.getRequest(serverUrl + "island.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	getCharacters() {
		var request = this.getRequest(serverUrl + "characters.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}

	getInspiration() {
		var request = this.getRequest(serverUrl + "inspiration.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	getBox() {
		var request = this.getRequest(serverUrl + "box.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	getJoe() {
		var request = this.getRequest(serverUrl + "joe.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}	
	
	getRumors() {
		var request = this.getRequest(serverUrl + "rumors.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}

	getReports() {
		var request = this.getRequest(serverUrl + "reports.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}

	getBestiary() {
		var request = this.getRequest(serverUrl + "bestiary.json?" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase());
		return this.getJson(request);
	}
	
	uploadFile(img) {
		var data = new FormData();
		data.append( "img", img );
		var request = this.postRequest(serverUrl + "images.php", data);
		return this.getText(request);
	}
	
}

var Ajax = new AjaxCalls();

export default Ajax;


// WEBPACK FOOTER //
// ./src/ajax/Ajax.js